<!--
  A row of headline numbers. Presentational only — the host computes the tiles, including their formatting,
  because "what counts as a good number here" is the host's business and this is just the box it sits in.

  Shared so the audience overview and the marketing dashboard read as the same screen furniture.
-->
<template>
  <v-row dense>
    <v-col
      v-for="tile in tiles"
      :key="tile.label"
      cols="6"
      :sm="sm"
      :md="md"
    >
      <v-sheet
        outlined
        rounded
        class="pa-3 text-center fill-height"
      >
        <v-skeleton-loader
          v-if="loading"
          type="heading"
        />
        <div
          v-else
          class="text-h5"
          :class="tile.color ? tile.color + '--text' : ''"
        >
          {{ tile.value }}
        </div>
        <div class="text-caption grey--text">
          {{ tile.label }}
        </div>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'StatTiles',
  props: {
    /** [{ label, value, color? }] — value is already formatted. */
    tiles: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    // Column widths, so a row of 6 and a row of 8 both fill their line.
    sm: {
      type: [String, Number],
      default: 4
    },
    md: {
      type: [String, Number],
      default: 2
    }
  }
};
</script>
